/**
 * Created by zhengyf 2017/8/24
 */

subAccountLoginSummaryCtrl.$inject = ['$scope', 'request'];
angular.module('subAccountLoginSummary', ['app.core']);

angular
    .module('subAccountLoginSummary')
    .controller('subAccountLoginSummaryCtrl', subAccountLoginSummaryCtrl);

function subAccountLoginSummaryCtrl($scope, request) {

    // ====================variable===========================

    var vm = $scope;

    vm.d = {
        userInfo: []
    };

    vm.f = {};

    var ipMock = {
        min: '58.61.221.0',
        max: '58.25.255.255'
    };

    // ====================function============================

    init();

    function init() {
        console.log('[sub account login summary init: ]');
        initGetSubAccountList();
    }

    /**
     * get sub account list
     */
    function initGetSubAccountList() {
        var url = '/usr/api/listSubAccount';
        request.get(url, {}, true).then(function (res) {
            res = res || {};
            handleData(res.data.subAccounts);

        }, errCallback);

        function errCallback(error) {
            DSSX.dialog.err(error, {
                moduleName: '子账号摘要',
                funcName: 'initGetSubAccountList',
                text: '获取子账号摘要失败'
            });
        }
    }

    /**
     * handle success return data
     */
    function handleData(res) {
        res = res || [];
        angular.forEach(res, function (ele) {
            var country = ele.contactAddress ? getCountry(ele.contactAddress.country, ele.contactAddress.province) : '';
            var o = {
                userName: ele.name.firstName + ' ' + ele.name.lastName,
                type: ele.type,
                status: ele.status,
                lastLoginTime: joinLastTime(),
                ip: getRandomIp(ipMock.min, ipMock.max),
                country: country
            }
            vm.d.userInfo.push(o);
        })

        function getCountry(country, province) {
            country = country || '';
            province = province || '';
            country = country.split(' ')[0];
            return country + ' ' + province;
        }
    }

    //随机返回minIp到maxIp之间的ip，包括minIp和maxIp
    function getRandomIp(minIp, maxIp) {
        var min = ipToInt(minIp);
        var max = ipToInt(maxIp);
        var randomNum = getRandomNum(min, max + 1);
        var ip = numToIp(randomNum);
        return ip;
    }

    //随机返回min到max之间的整数，但不包括max
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    /**
     * number to ip
     */
    function numToIp(number) {
        var ip = number % 256;
        for (var i = 1; i <= 3; i++) {
            number = Math.floor(number / 256);
            ip = number % 256 + '.' + ip;
        }
        return ip;
    }

    /**
     * ip to number
     */
    function ipToInt(ip) {
        var REG = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        var result = REG.exec(ip);
        if (!result) return -1;
        return (parseInt(result[1]) << 24
            | parseInt(result[2]) << 16
            | parseInt(result[3]) << 8
            | parseInt(result[4]));
    }

    // generate last login time
    /**
     * join last login time
     */
    function joinLastTime() {
        var hour = randomTime(24);
        var minute = randomTime(24);
        var sec = randomTime(24);
        var date = setLastDateMock();
        return date + ' ' + hour + ':' + minute + ':' + sec;
    }

    /**
     * set newest date
     */
    function setLastDateMock() {
        var curDate = new Date();
        curDate = curDate.toLocaleDateString().split('/');
        var d1 = randomTime(+curDate[1]);
        if (+d1 <= 0) {
            d1 = '01';
        }
        var d2 = randomTime(+curDate[2]);
        if (+d2 <= 0) {
            d2 = '01'
        }
        return curDate[0] + '-' + d1 + '-' + d2;
    }

    /**
     * random number
     */
    function randomTime(max) {
        var d = Math.round(Math.random() * max).toString();
        if (d.length <= 1) {
            d = '0' + d;
        }
        return d;
    }

}
